import { Injectable } from '@angular/core';
import { DataService } from 'app/_services/datamanager.service';
import { AlertService } from 'app/_services/alert.service';
import { LogService} from 'app/_services/logmanager.service';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { GlobalsService } from 'app/_services/globals.service';

import { map } from 'rxjs/operators';

@Injectable()
export class RolsPermissionGuard implements CanActivate {

    errorMessage: string;

    constructor(
        private alertService: AlertService,
        private dataService: DataService,
        private router: Router,
        private globalStorage: GlobalsService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        LogService.log('RolsPermissionGuard', 'rolsPermissionGuard -> canActivate' );

        const params = <any>{
            'accio': 'WsHasPermis',
            'params': <any> {
                'secretaria_id' : this.globalStorage.getItem('secretaria'),
                'permission' : 'modificar_rols'
            },
        };
        return this.dataService.getData(params)
            .pipe(map(
            data => {
                LogService.log('RolsPermissionGuard', data);

                if (!data[0]) {
                    this.router.navigate(['/nopermission']);
                    return false;
                }
                return true;

            },
            (error: any) => {
                this.errorMessage = <any>error;
                this.alertService.error(this.errorMessage);
                return true;
            }

        ));
    }
}
